import { blockCategories } from '../../categories';
import { DEFAULT_ICON_SVG, extractSvgMarkup } from './iconSvg';

const COMPONENT_TYPE = 'sio-icon';
const BLOCK_ID = 'sio-icon';

export default function iconBlock(editor) {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    domComponents.addType(COMPONENT_TYPE, {
        isComponent: (el) => {
            if (
                el?.classList?.contains('sio-icon') ||
                el?.getAttribute?.('data-siotype') === COMPONENT_TYPE
            ) {
                const innerSvg = el.querySelector?.('svg');
                const parsed = { type: COMPONENT_TYPE };
                if (innerSvg) {
                    parsed.svgCode = extractSvgMarkup(innerSvg.outerHTML);
                }
                return parsed;
            }
            return undefined;
        },
        model: {
            defaults: {
                tagName: 'span',
                name: 'Icon',
                'custom-name': 'Icon',
                droppable: false,
                draggable: true,
                stylable: true,
                highlightable: true,
                editable: false,
                copyable: true,
                resizable: {
                    ratioDefault: true,
                    tl: 1,
                    tc: 0,
                    tr: 1,
                    cl: 0,
                    cr: 1,
                    bl: 1,
                    bc: 0,
                    br: 1,
                },
                svgCode: DEFAULT_ICON_SVG,
                attributes: {
                    class: 'sio-icon',
                    'data-siotype': COMPONENT_TYPE,
                },
                style: {
                    display: 'inline-flex',
                    width: '24px',
                    height: '24px',
                    color: 'currentColor',
                },
                traits: [
                    {
                        type: 'svg-icon-editor',
                        name: 'svgCode',
                        label: 'Icon',
                        changeProp: 1,
                    },
                ],
                components: [],
            },

            init() {
                this.clearParsedChildren();
                this.on('change:svgCode', this.onSvgCodeChange);
                this.onSvgCodeChange();
            },

            clearParsedChildren() {
                if (this.components()?.length) {
                    this.components([]);
                }
            },

            onSvgCodeChange() {
                const svg = extractSvgMarkup(this.get('svgCode'));
                if (svg !== this.get('svgCode')) {
                    this.set('svgCode', svg, { silent: true });
                }
                this.getView?.()?.renderSvg?.();
            },
        },
        view: {
            events: {
                dblclick: 'openFilePicker',
            },
            onRender() {
                this.renderSvg();
            },
            renderSvg() {
                const el = this.el;
                if (!el) return;
                const svg = extractSvgMarkup(this.model.get('svgCode'));
                el.innerHTML = svg;
                const svgEl = el.querySelector('svg');
                if (svgEl) {
                    svgEl.setAttribute('aria-hidden', 'true');
                    svgEl.style.display = 'block';
                    svgEl.style.width = '100%';
                    svgEl.style.height = '100%';
                    svgEl.style.pointerEvents = 'none';
                }
            },
            openFilePicker(e) {
                e?.stopPropagation?.();
                const input = document.createElement('input');
                input.type = 'file';
                input.accept = '.svg,image/svg+xml';
                input.addEventListener('change', () => {
                    const file = input.files?.[0];
                    if (!file) return;
                    const reader = new FileReader();
                    reader.onload = () => {
                        const svg = extractSvgMarkup(String(reader.result || ''));
                        if (svg) this.model.set('svgCode', svg);
                    };
                    reader.readAsText(file);
                });
                input.click();
            },
        },
    });

    blockManager.add(BLOCK_ID, {
        label: 'Icon',
        category: blockCategories.basic,
        media: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor" d="M12 2l2.4 7.2H22l-6 4.8 2.3 7.2L12 16.8 5.7 21.2 8 14 2 9.2h7.6L12 2z"/>
        </svg>`,
        content: {
            type: COMPONENT_TYPE,
            svgCode: DEFAULT_ICON_SVG,
            attributes: {
                class: 'sio-icon',
                'data-siotype': COMPONENT_TYPE,
            },
        },
    });
}
